import React from 'react';
import { Text } from '@chakra-ui/react';

const capitalizeWords = (str) => {
  return str?.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

const Badge = ({ color, bgColor, text, ...rest }) => {
  return (
    <Text
      color={color}
      bgColor={bgColor}
      fontSize={10}
      fontWeight={800}
      whiteSpace={'nowrap'}
      padding={'4px 8px 4px 8px'}
      borderRadius={80}
      w={'fit-content'}
      h={'fit-content'}
      {...rest}
    >
      {capitalizeWords(text)}
    </Text>
  );
};

export default Badge;
